import {
    GET_CHILDREN,
    GET_CHILDREN_SUCCESS,
    GET_CHILDREN_ERROR,
    SET_CHILDREN_SELECTED,
    SET_CHILDREN_GRADES,
} from '../constants'

// The clinician's students. `loading` is about the students only (the grades come separately and used to switch it off
// when they arrived first, so the student picker showed "Add your first student" to people with students); `loaded`
// says the list has come at least once (a list already shown stays while it's fetched again); `error` when it couldn't
// be fetched (the picker offers Try again instead of loading forever).
export const initialState = {
    children: [],
    loading: true,
    loaded: false,
    error: false,
    childrenSelected: [],
    grades: null,
}

export default function (state = initialState, action) {
    switch (action.type) {
        case GET_CHILDREN: {
            return { ...state, loading: !state.loaded, error: false }
        }
        case GET_CHILDREN_SUCCESS: {
            return { ...state, children: action.payload, loading: false, loaded: true, error: false }
        }
        case GET_CHILDREN_ERROR: {
            return { ...state, loading: false, error: true }
        }
        case SET_CHILDREN_SELECTED: {
            return { ...state, childrenSelected: action.payload }
        }
        case SET_CHILDREN_GRADES: {
            return { ...state, grades: { all: 'All', ...action.payload } }
        }
        default:
            return state
    }
}
